import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import AdminRoutes from "../Admin/AdminRoutes";
import SideNav from "../Base/SideNav";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  content: {
    marginLeft: "5rem",
    height: "100%",
    overflowY: "auto",
  },
}));

export default function AdminHome() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <SideNav />
      <main className={classes.content}>
        <Container style={{ height: "100%" }}>
          <AdminRoutes />
        </Container>
      </main>
    </div>
  );
}
